function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function splitHeroHeadingLines() {
  var heading = document.querySelector('.js-marker-middle-row .js-marker-heading');
  if (!heading || heading.dataset.heroSplit === 'true') return { heading: heading, innerEls: [] };

  // Heading content comes from the block's rich-text field, so the wrapping
  // tag (h1, p, ...) can change without notice — grab whatever element it is
  // instead of assuming <p>.
  var target = heading.firstElementChild || heading;
  var lines = target.innerHTML
    .split(/<br\s*\/?>/i)
    .map(function (line) {
      var probe = document.createElement('span');
      probe.innerHTML = line;
      return (probe.textContent || '').trim();
    })
    .filter(Boolean);

  if (lines.length < 2) return { heading: heading, innerEls: [] };

  target.textContent = '';

  var innerEls = [];

  lines.forEach(function (line, index) {
    if (index > 0) {
      target.appendChild(document.createTextNode(' '));
    }

    var mask = document.createElement('span');
    mask.className = 'hero-line-mask';
    mask.style.display = 'block';
    mask.style.overflow = 'hidden';
    // Extra room above the line so accented letters (Ö, Ü, Ş …) don't get
    // clipped by the reveal mask; negative margin keeps the visible
    // position unchanged.
    mask.style.paddingTop = '0.25em';
    mask.style.marginTop = '-0.25em';
    mask.style.paddingBottom = '0.25em';
    mask.style.marginBottom = '-0.25em';

    var inner = document.createElement('span');
    inner.className = 'hero-line-inner';
    inner.style.position = 'relative';
    inner.style.display = 'inline-block';
    inner.textContent = line;

    mask.appendChild(inner);
    target.appendChild(mask);
    innerEls.push(inner);
  });

  heading.dataset.heroSplit = 'true';
  return { heading: heading, innerEls: innerEls };
}

function animateHeroHeading(heading, innerEls) {
  innerEls.forEach(function (inner, index) {
    inner.animate([{ transform: 'translateY(115%)' }, { transform: 'translateY(0)' }], {
      duration: 900,
      delay: index * 150,
      easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
      fill: 'forwards',
    });
  });

  // Not: burada önceden background-clip:text ile hareket eden bir "shimmer"
  // (parlama geçişi) katmanı vardı. Gerçek tarayıcıda doğrulandı: bu katman
  // asıl metnin üzerine tam hizalanmıyor, hafif kaymış bir ikinci kopya gibi
  // render olup harfleri kabartma/oyma gibi gösteriyordu. Kaldırıldı —
  // aşağıdaki kehribar parıltı animasyonu zaten başlığın canlı hissini
  // sağlıyor, sorunsuz.

  // Sürekli, çok yumuşak bir "nefes alan" kehribar parıltısı — tek seferlik
  // satır açılışı ve kayan shimmer'ın üstüne, başlığın canlı/animasyonlu
  // olduğu her an belli olsun diye. Marka paletinden #E4AB5D (kehribar).
  //
  // İlk gölge katmanı (ink #1A1208, sabit, TEK ve İNCE) kontrast için var:
  // hero zemini canlı/animasyonlu bir kırmızı→amber gradyan, ve krem
  // (#FDF6EC) metin gradyanın amber ucunda WCAG AA'yı geçemiyor (~1.9:1).
  // Bu satır her iki keyframe'de de AYNI değerde kalıyor (sadece kehribar
  // parıltısı nabız atıyor) böylece kontrast desteği hiç kaybolmuyor.
  // ÖNEMLİ: 144px'lik (9rem) dev harflerde büyük blur yarıçaplı/çoklu
  // gölge katmanları harflerin kabartma/oyma gibi görünmesine sebep oluyor
  // (denendi, gerçek tarayıcıda doğrulandı) — bu yüzden gölge TEK katman
  // ve küçük blur (2px) ile sınırlı tutuluyor.
  if (heading) {
    heading.animate(
      [
        {
          textShadow: '0 1px 2px rgba(26, 18, 8, 0.35), 0 0 0px rgba(228, 171, 93, 0)',
        },
        {
          textShadow: '0 1px 2px rgba(26, 18, 8, 0.35), 0 0 14px rgba(228, 171, 93, 0.45)',
        },
        {
          textShadow: '0 1px 2px rgba(26, 18, 8, 0.35), 0 0 0px rgba(228, 171, 93, 0)',
        },
      ],
      {
        duration: 4200,
        delay: 1300,
        easing: 'ease-in-out',
        iterations: Infinity,
        fill: 'backwards',
      }
    );
  }
}

function animateHeroBackground(hero) {
  var start = hero.getAttribute('data-gradient-start');
  var end = hero.getAttribute('data-gradient-end');
  if (!start || !end) return;

  var flow = document.createElement('div');
  flow.setAttribute('aria-hidden', 'true');
  flow.style.position = 'absolute';
  flow.style.top = '0';
  flow.style.left = '0';
  flow.style.right = '0';
  flow.style.bottom = '0';
  flow.style.width = '100%';
  flow.style.height = '100%';
  flow.style.zIndex = '0';
  var noiseSvg =
    "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='180' height='180'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")";
  flow.style.backgroundImage = noiseSvg + ', linear-gradient(90deg, ' + start + ', ' + end + ')';
  flow.style.backgroundSize = '180px 180px, 300% 100%';
  flow.style.backgroundBlendMode = 'overlay, normal';
  flow.style.backgroundRepeat = 'repeat, no-repeat';

  hero.insertBefore(flow, hero.firstChild);

  flow.animate(
    [
      { backgroundPosition: '0 0, 0% 50%' },
      { backgroundPosition: '0 0, 100% 50%' },
      { backgroundPosition: '0 0, 0% 50%' },
    ],
    { duration: 10000, easing: 'ease-in-out', iterations: Infinity }
  );
}

function animateHeroButton(hero) {
  var button = hero.querySelector('.button-custom');
  if (!button) return;

  var breathe = button.animate(
    [
      { boxShadow: '0 6px 16px -8px rgba(0,0,0,0.25)', transform: 'scale(1)' },
      { boxShadow: '0 14px 28px -10px rgba(0,0,0,0.38)', transform: 'scale(1.015)' },
      { boxShadow: '0 6px 16px -8px rgba(0,0,0,0.25)', transform: 'scale(1)' },
    ],
    { duration: 3600, easing: 'cubic-bezier(0.45, 0, 0.55, 1)', iterations: Infinity }
  );

  var shine = document.createElement('span');
  shine.setAttribute('aria-hidden', 'true');
  shine.style.position = 'absolute';
  shine.style.inset = '0';
  shine.style.zIndex = '1';
  shine.style.pointerEvents = 'none';
  shine.style.backgroundImage =
    'linear-gradient(100deg, transparent 40%, rgba(190,66,58,0.12) 50%, transparent 60%)';
  shine.style.backgroundSize = '260% 100%';
  shine.style.backgroundRepeat = 'no-repeat';
  button.appendChild(shine);

  var shineAnim = shine.animate([{ backgroundPosition: '140% 0' }, { backgroundPosition: '-140% 0' }], {
    duration: 7000,
    easing: 'ease-in-out',
    iterations: Infinity,
  });

  var pause = function () {
    breathe.pause();
    shineAnim.pause();
  };
  var resume = function () {
    breathe.play();
    shineAnim.play();
  };

  button.addEventListener('mouseenter', pause);
  button.addEventListener('mouseleave', resume);
  button.addEventListener('focus', pause);
  button.addEventListener('blur', resume);
}

function initHeroMotion() {
  var hero = document.querySelector('.js-marker-hero-section');
  var split = splitHeroHeadingLines();

  if (!hero) {
    console.warn('[hero-heading] .js-marker-hero-section not found — background/button animation skipped.');
  }
  if (split.innerEls.length === 0) {
    console.warn('[hero-heading] heading lines not found/split — title reveal skipped.');
  }

  if (prefersReducedMotion()) return;

  if (hero) {
    animateHeroBackground(hero);
    animateHeroButton(hero);
  }

  animateHeroHeading(split.heading, split.innerEls);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeroMotion);
} else {
  initHeroMotion();
}

// Tema düzenleyicide bir bölüm düzenlenince Shopify o bölümün DOM'unu
// tamamen yeniden oluşturuyor (yeni elementler, eski animasyonlar/flow
// katmanı ile birlikte kayboluyor) ama sayfa yenilenmiyor — bu yüzden
// DOMContentLoaded bir daha tetiklenmiyor. Yeniden yüklenen bölüm hero ise
// animasyonları o yeni DOM üzerinde baştan başlatıyoruz.
document.addEventListener('shopify:section:load', function (event) {
  if (event.target.querySelector('.js-marker-hero-section')) {
    initHeroMotion();
  }
});
